var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideTopbar)?_c('cmpPageTopbar'):_vm._e(),_c('cmpDialogLogin'),_c('cmpDialogChangePwd'),_c('cmpDialogRegist'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }